"use strict";function translateVoice$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.translateVoice$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.audio.translateVoice";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.8.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.8.0"},_a)),exports.translateVoice$=translateVoice$,exports.default=translateVoice$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/audio/translateVoice.js
// module id = 1050
// module chunks = 106